/**
 * 平台菜单 - 报表
 */

export default [
  {
    label: 'menu.report001', //报表台账
    icon: 'icon-tongjichaxun',
    path: '/report',
    permission: 'taxcloud6005',
    id:'6005',
    children: [
      {
        label: 'menu.report002', //财务报表
        icon: 'm-caiwubaobiao',
        path: '/financial/financialStatementAccounting.action',
        permission: 'taxcloud7050',
        id:'7050'
      },
      {
        label: 'menu.report003', //明细报表
        icon: 'm-mingxibaobiao',
        path: '/statistic/menu_reportDetail.action',
        permission: 'taxcloud6200',
        id:'6200'
      },
      {
        label: 'menu.report004', //资产管理
        icon: 'm-zichanguanli',
        path: '/statistic/menu_reportAssets.action',
        permission: 'taxcloud6100',
        id:'6100'
      },
      {
        label: 'menu.report005', //费用报表
        icon: 'm-feiyongbaobiao',
        path: '/statistic/menu_reportFee.action',
        permission: 'taxcloud6300',
        id:'6300'
      },
      {
        label: 'menu.report006', //可视化视图
        icon: 'm-keshihuashitu',
        path: '/financial/custom_visual.action',
        permission: 'taxcloud6400',
        id:'6400'
      },
      {
        label: 'menu.report007', //合同余额报表
        icon: 'm-hetongyuebaobiao',
        path: '/statistic/menu_reportContract.action',
        permission: 'taxcloud6069',
        id:'6069'
      },
      {
        label: 'menu.report008', //税金查询
        icon: 'm-shuijinchaxun',
        path: '/statement/toTax.action',
        permission: 'taxcloud6067',
        id:'6067'
      },
      {
        label: 'menu.report009', //客户日记账
        icon: 'm-jizhang',
        path: '/statement/toCustomerDaily.action',
        permission: 'taxcloud6015',
        id:'6015'
      },
      {
        label: 'menu.report010', //发票查询
        icon: 'm-fapiaochaxun',
        path: '/statistic/statistic_toNoBillCost.action',
        permission: 'taxcloud6024',
        id:'6024'
      },

    ]
  }
];
